export default "__VITE_ASSET__ce63b568__"